/**
 * Public Share Pass recipient bridge.
 *
 * Production: the ALB routes `veralok.com/share/{id}` directly to
 * FastAPI's Jinja SSR — this component never renders because the SPA
 * catch-all is never reached.
 *
 * Preview environment: the ingress reserves non-`/api/*` paths for
 * this React SPA. This component detects it landed on `/share/{id}`,
 * then hands off to the FastAPI mirror at `/api/share_page/{id}` so
 * the recipient always sees the same branded SSR page — no second
 * implementation of the recipient UI lives in React.
 */
import { useEffect } from "react";
import { useParams } from "react-router-dom";

export default function ShareRecipientBridge() {
  const { id } = useParams();
  useEffect(() => {
    if (!id) return;
    // Preserve any query string the sender may have appended.
    const qs = window.location.search || "";
    window.location.replace(`/api/share_page/${encodeURIComponent(id)}${qs}`);
  }, [id]);
  return (
    <div
      data-testid="share-recipient-bridge"
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#0B1220",
        color: "#94A3B8",
        fontFamily: "-apple-system, BlinkMacSystemFont, sans-serif",
        fontSize: 14,
        letterSpacing: 0.3,
      }}
    >
      Loading Share Pass…
    </div>
  );
}
